export default __webpack_public_path__ + "static/media/CA-15 click reveal access token.f5c0bb55.png";